import broker from '@utils/broker'

export const state = {

}

export const mutations = {

}

export const getters = {

}

export const actions = {

  insertData({
    commit,
    dispatch,
    getters
  }, {
    url,
    body,
    throwOnError = false
  } = {}) {
    return broker.fetch.post(url, body)
      .then(res => {
        return res
      }).catch(err => {
        if (err.response && err.response.status === 401) {
          commit('SET_CURRENT_USER', null)
          window.localStorage.clear();
          alert('Maaf, Session anda telah habis');
          window.location.reload();
        }
        if (throwOnError) throw err
        return null
      });
  },

  updateData({
    commit,
    dispatch,
    getters
  }, {
    url,
    body,
    throwOnError = false
  } = {}) {
    return broker.fetch.patch(url, body)
      .then(res => {
        return res
      }).catch(err => {
        if (err.response && err.response.status === 401) {
          commit('SET_CURRENT_USER', null)
          window.localStorage.clear();
          alert('Maaf, Session anda telah habis');
          window.location.reload();
        }
        if (throwOnError) throw err
        return null
      });
  },

  updateDataPost({
    commit,
    dispatch,
    getters
  }, {
    url,
    body
  } = {}) {
    return broker.fetch.post(url, body)
      .then(res => {
        return res
      }).catch(err => {
        if (err.response && err.response.status === 401) {
          commit('SET_CURRENT_USER', null)
          window.localStorage.clear();
          alert('Maaf, Session anda telah habis');
          window.location.reload();
        }
        return null
      });
  },

  uploadFormData({
    commit,
    dispatch,
    getters
  }, {
    url,
    body
  } = {}) {
    return broker.fetchFormData.post(url, body)
      .then(res => {
        return res
      })
      .catch(err => {
        if (err.response && err.response.status === 401) {
          commit('SET_CURRENT_USER', null)
          window.localStorage.clear();
          alert('Maaf, Session anda telah habis');
          window.location.reload();
        }
        return null
      });
  },

  getData({
    commit,
    dispatch,
    getters
  }, {
    url
  } = {}) {
    return broker.fetch.get(url)
      .then(res => {
        return res
      }).catch(err => {
        if (err.response && err.response.status === 401) {
          commit('SET_CURRENT_USER', null)
          window.localStorage.clear();
          alert('Maaf, Session anda telah habis');
          window.location.reload();
        }
        return null
      });
  },

  listData({
    commit,
    dispatch,
    getters
  }, {
    url
  } = {}) {
    return broker.fetch.get(url)
      .then(res => {
        return res
      }).catch(err => {
        if (err.response && err.response.status === 401) {
          commit('SET_CURRENT_USER', null)
          window.localStorage.clear();
          alert('Maaf, Session anda telah habis');
          window.location.reload();
        }
        return null
      });
  },

  deleteData({
    commit,
    dispatch,
    getters
  }, {
    url
  } = {}) {
    return broker.fetch.delete(url)
      .then(res => {
        return res
      })
  },

  cariData({
    commit,
    dispatch,
    getters
  }, {
    url
  } = {}) {
    return broker.fetch.get(url)
      .then(res => {
        if (res.data.data) {
          return res.data.data
        } else {
          return null
        }
      }).catch(err => {
        if (err.response && err.response.status === 401) {
          commit('SET_CURRENT_USER', null)
          window.localStorage.clear();
          alert('Maaf, Session anda telah habis');
          window.location.reload();
        }
        return null
      });
  },

  downloadData({
    commit,
    dispatch,
    getters
  }, {
    url
  } = {}) {
    return broker.fetch.get(url, {
        responseType: 'blob'
      })
      .then(res => {
        return res
      }).catch(err => {
        if (err.response && err.response.status === 401) {
          commit('SET_CURRENT_USER', null)
          window.localStorage.clear();
          alert('Maaf, Session anda telah habis');
          window.location.reload();
        }
        return null
      });
  },

}
